import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { ChangePasswordModal } from "../common/ChangePasswordModal";

export const Topbar: React.FC<{ onMenuClick: () => void }> = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-slate-200 dark:border-industrial-700 bg-white/90 dark:bg-industrial-900/90 backdrop-blur px-4">
      <button className="lg:hidden text-slate-500" onClick={onMenuClick} aria-label="Toggle menu">
        ☰
      </button>
      <div className="hidden lg:block" />
      <div className="flex items-center gap-3">
        <button onClick={toggleTheme} className="btn-secondary !px-2 !py-1.5" title="Toggle dark mode">
          {theme === "light" ? "🌙" : "☀️"}
        </button>
        <button
          onClick={() => setShowChangePassword(true)}
          className="text-right hidden sm:block hover:opacity-75 transition-opacity"
          title="Change password"
        >
          <p className="text-sm font-medium">{user?.fullName}</p>
          <p className="text-xs text-slate-400">{user?.roleCode}</p>
        </button>
        <button onClick={logout} className="btn-secondary">
          Log out
        </button>
      </div>

      <ChangePasswordModal open={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </header>
  );
};
